/* eslint-disable object-curly-newline */
export default [
	{
		status: 200,
		data: {
			code: 200,
			message: "L'utilisateur a bien été trouvé.",
			data: {
				sub: '685bfd4a-4138-48e4-9887-29f5d8702cfb',
				email_verified: 'true',
				name: 'Hubert',
				locale: 'fr',
				family_name: 'Meffe',
				email: 'hubert@centiva.ca',
				picture: 'https://via.placeholder.com/150',
			},
		},
	},
	{
		status: 200,
		data: {
			code: 200,
			message: "L'utilisateur a bien été trouvé.",
			data: {
				sub: '29f5d8702cfb-4138-48e4-685bfd4a-9887',
				email_verified: 'true',
				name: 'Fayek',
				locale: 'fr',
				family_name: 'Helmi',
				email: 'Fayek@centiva.ca',
				picture: 'https://via.placeholder.com/220',
			},
		},
	},
	{
		status: 200,
		data: {
			code: 200,
			message: "L'utilisateur a bien été trouvé.",
			data: {
				sub: '685bfd4a-4138-48e4-1234-29f5d8702cfb',
				email_verified: 'true',
				name: 'Julep',
				locale: 'fr',
				family_name: 'Helgag',
				email: 'Julep@centiva.ca',
				picture: 'https://via.placeholder.com/120',
			},
		},
	},
];
